<div
  class="input-wrapper"
  [class.input-wrapper--focused]="isFocused()"
  [class.input-wrapper--error]="showError"
  [class.input-wrapper--disabled]="disabled"
>
  <!-- Slot icône gauche -->
  <span class="input-icon input-icon--left">
    <ng-content select="[slot='icon-left']"></ng-content>
  </span>

  <!-- Champ natif -->
  <input
    class="input-field"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [required]="required"
    [value]="value()"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />

  <!-- Bouton effacer — visible uniquement si du texte est présent -->
  @if (value() && clearable) {
    <button
      class="input-clear-btn"
      type="button"
      (click)="onClear()"
      (mousedown)="$event.preventDefault()"
      aria-label="Effacer">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.27337 14.7266C1.63786 15.0911 2.22881 15.0911 2.5933 14.7266L8 9.31993L13.4067 14.7266C13.7712 15.0911 14.3621 15.0911 14.7266 14.7266C15.0911 14.3621 15.0911 13.7712 14.7266 13.4067L9.31993 8L14.7266 2.5933C15.0911 2.22881 15.0911 1.63786 14.7266 1.27337C14.3621 0.908878 13.7712 0.908878 13.4067 1.27337L8 6.68007L2.5933 1.27337C2.22881 0.908878 1.63786 0.908878 1.27337 1.27337C0.908878 1.63786 0.908878 2.22881 1.27337 2.5933L6.68007 8L1.27337 13.4067C0.908878 13.7712 0.908878 14.3621 1.27337 14.7266Z" fill="#121212"/>
      </svg>
    </button>
  }

  <!-- Slot icône droite -->
  <!-- <span class="input-icon input-icon--right">
    <ng-content select="[slot='icon-right']"></ng-content>
  </span> -->
</div>

<!-- Message d'erreur -->
<span class="input-error" *ngIf="showError" role="alert">
  {{ errorMessage }}
</span>